import React from "react";
import CompWrapper from "../../hoc/compWrapper/CompWrapper.hoc";
import IntroductionPage from "../../introductionPage/IntroductionPage";
export const AboutArsp = () => {
  return <IntroductionPage />;
};
